// extracted by mini-css-extract-plugin
export var details = "_g9-0";
export var inspectorPopover = "_g9-1";